export const GET_THEME_REQUEST = 'GET_THEME_REQUEST';
export const GET_THEME_SUCCESS = 'GET_THEME_SUCCESS';
export const GET_THEME_FAIL = 'GET_THEME_FAIL';
